import React from 'react';
import './Mentorslistmodalbox.css';
import { useTriggers } from '../../hooks/navigation';
import { useSelector } from 'react-redux';
import useMentors from '../../hooks/api/mentors/useMentors';
import {
  handleLayoutsWithCustomTooltipsJS,
  userIsOnTrial,
} from '../../utils/shared';
import NoRecordFound from '../NoRecordFound/NoRecordFound';
import { IBLSpinLoader } from '@acilearning/ibl-web-react-common';
import { useTranslation } from 'react-i18next';
import { useDebounce } from '../../hooks/useDebounce';
import IBLPagination from '../../modules/pagination/IBLPagination';

const Mentorslistmodalbox = (props) => {
  const {
    handleModalCloseClick,
    _handleUpdateModalStatus,
    handleCreateMentorBtnClick,
    handleOpenFreeTrialModal,
  } = useTriggers();

  const {
    loadingMentors: loading,
    page,
    handleSetPage,
    numPages,
    mentorsToDisplay,
    handleSearchChange,
    handleFeaturedStateChanged,
    handleMentorItemSelect,
    hasLoadedOnce,
  } = useMentors();

  useDebounce(handleLayoutsWithCustomTooltipsJS, 200, []);

  const mentors = useSelector((state) => state.mentors);
  const { t } = useTranslation();

  return (
    <div
      className="modal mentor-list-modal"
      onClick={(e) => {
        e.stopPropagation();
        _handleUpdateModalStatus('mentor-list-modal', false);
      }}
    >
      <div
        className="w-layout-vflex modal-container mentor-list-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-layout-hflex modal-header">
          <h3 className="modal-header-title">Mentors</h3>
          <div
            className="modal-close-wrapper"
            data-w-id="cf15a9d9-a59b-1c17-f2d2-4a35c02cd588"
            onClick={handleModalCloseClick}
            prop-events-value-onclick="handleModalCloseClick"
          >
            <img alt="" loading="lazy" src="/images/close_1close.png" />
          </div>
        </div>
        <div className="w-layout-vflex modal-body user-settings-modal-body">
          <div className="text-block-25">
            {t('Showing list of mentors used with the mentorAI')}
          </div>
          <div className="w-layout-hflex table-top-header-block">
            <div className="w-layout-hflex search-box-block all-whiten-in-dark-mode">
              <img
                alt=""
                className="image-49"
                loading="lazy"
                src="/images/search-1.svg"
              />
              <div className="search-box-form-block w-form">
                <form
                  data-name="Email Form 4"
                  data-wf-element-id="40a54b0a-56f4-f227-3a60-bdd130d6bc72"
                  data-wf-page-id="650305782bc61751e5765214"
                  id="email-form-4"
                  method="get"
                  name="email-form-4"
                >
                  <input
                    className="text-field-4 w-input"
                    data-name="Name 5"
                    id="name-5"
                    maxLength={256}
                    name="name-5"
                    onChange={handleSearchChange}
                    placeholder="Search mentors"
                    type="text"
                  />
                </form>
              </div>
            </div>
            <div
              className="button-with-icon users-settings-invite-btn"
              data-w-id="40a54b0a-56f4-f227-3a60-bdd130d6bc7a"
              onClick={
                userIsOnTrial()
                  ? handleOpenFreeTrialModal
                  : handleCreateMentorBtnClick
              }
              prop-events-value-onclick="handleCreateMentorBtnClick"
            >
              <img
                alt=""
                className="button-icon"
                loading="lazy"
                src="/images/plus.svg"
                width={70}
              />
              <div className="button-text">{t('Create Mentor')}</div>
            </div>
          </div>
          <div className="w-layout-vflex table-container">
            <div className="w-layout-hflex table-header">
              <div className="table-block table-block-big all-whiten-in-dark-mode">
                <h5 className="table-title">{t('NAME')}</h5>
                <img
                  src="/images/arrow-up-down.svg"
                  loading="lazy"
                  alt=""
                  className="user-table-sort-icon"
                />
              </div>
              <div className="table-block table-block-medium all-whiten-in-dark-mode llm">
                <h5 className="table-title">{t('LLM')}</h5>
                <img
                  src="/images/arrow-up-down.svg"
                  loading="lazy"
                  alt=""
                  className="user-table-sort-icon"
                />
              </div>
              <div className="table-block table-block-medium all-whiten-in-dark-mode">
                <h5 className="table-title">{t('PROVIDER')}</h5>
                <img
                  src="/images/arrow-up-down.svg"
                  loading="lazy"
                  alt=""
                  className="user-table-sort-icon"
                />
              </div>
              <div className="table-block table-block-very-large all-whiten-in-dark-mode">
                <h5 className="table-title">{t('DESCRIPTION')}</h5>
                <img
                  src="/images/arrow-up-down.svg"
                  loading="lazy"
                  alt=""
                  className="user-table-sort-icon hidden"
                />
              </div>
              <div className="table-block table-block-big all-whiten-in-dark-mode dataset">
                <h5 className="table-title">{t('UPDATED ON')}</h5>
                <img
                  src="/images/arrow-up-down.svg"
                  loading="lazy"
                  alt=""
                  className="user-table-sort-icon"
                />
              </div>
              <div className="table-block table-block-small all-whiten-in-dark-mode">
                <h5 className="table-title text-center">{t('FEATURED')}</h5>
              </div>
            </div>

            {loading && <IBLSpinLoader size={30} containerHeight={'100px'} />}
            {hasLoadedOnce && !loading && !mentorsToDisplay?.length && (
              <NoRecordFound />
            )}
            {!loading &&
              mentorsToDisplay?.map((mentor) => (
                <div
                  className="w-layout-hflex table-body-row greyish-bg-in-darkmode"
                  key={mentor?.id}
                >
                  <div
                    data-w-id="46795521-760f-2cea-506b-a8c4b8a35614"
                    className="table-block table-block-big bold-in-dark-mode"
                  >
                    <a
                      data-w-id="46795521-760f-2cea-506b-a8c4b8a35615"
                      className="table-text-link w-inline-block"
                      onClick={(event) => handleMentorItemSelect(event, mentor)}
                      href="#"
                    >
                      <div className="table-text">{mentor?.name}</div>
                      <div className="tooltip table-tooltip">
                        {mentor?.name}
                      </div>
                    </a>
                    <div className="w-layout-hflex anonymous-switch-container">
                      <div
                        data-w-id="46795521-760f-2cea-506b-a8c4b8a3561b"
                        className="w-layout-hflex anonymous-switch-block"
                      >
                        <img
                          src="https://cdn.prod.website-files.com/67238084c08ebd191d57bd8e/67238084c08ebd191d57be9d_eye-off%20(2).svg"
                          loading="lazy"
                          alt=""
                          className="anonymous-switch-icon"
                        />
                        <div className="tooltip anonymous-mode">
                          Activate Anonymous Mode
                        </div>
                      </div>
                      <div
                        data-w-id="46795521-760f-2cea-506b-a8c4b8a3561f"
                        className="w-layout-hflex anonymous-switch-block is-anonymous hidden"
                      >
                        <img
                          src="https://cdn.prod.website-files.com/67238084c08ebd191d57bd8e/67238084c08ebd191d57bda6_eye%20(1).svg"
                          loading="lazy"
                          alt=""
                          className="anonymous-switch-icon img-whiten"
                        />
                        <div className="tooltip anonymous-mode deactivate">
                          Deactivate Anonymous Mode
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-block table-block-medium">
                    <div className="table-text">{mentor?.llm_name}</div>
                  </div>
                  <div className="table-block table-block-medium">
                    <div className="table-text">{mentor?.llm_provider}</div>
                  </div>
                  <div className="table-block table-block-very-large">
                    <div className="table-text">
                      <em className="italic-text line-clamp-2">
                        {mentor?.description}
                      </em>
                      <br />
                    </div>
                  </div>
                  <div className="table-block table-block-big">
                    <div className="table-text">
                      {mentor?.created_at &&
                        new Date(mentor.created_at).toLocaleDateString(
                          'en-US',
                          {
                            month: '2-digit',
                            day: '2-digit',
                            year: 'numeric',
                          }
                        )}
                      <br />
                    </div>
                  </div>
                  <div className="table-block table-block-small">
                    <div className="user-row-switcher-embed w-embed">
                      <label
                        className="user-switcher"
                        title={
                          !userIsOnTrial()
                            ? 'Toggle featured status'
                            : 'This feature is available in our paid tier'
                        }
                        style={{
                          cursor: !userIsOnTrial() ? 'pointer' : 'not-allowed',
                        }}
                      >
                        <input
                          disabled={userIsOnTrial()}
                          onChange={(event) =>
                            handleFeaturedStateChanged(
                              mentor,
                              event.target.checked
                            )
                          }
                          defaultChecked={
                            typeof mentor?.metadata === 'string'
                              ? JSON.parse(mentor?.metadata)?.featured
                              : mentor?.metadata?.featured
                          }
                          type="checkbox"
                        />
                        <span className="user-switcher-slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          {mentors?.mentors && (
            <div className="mentors-pagination">
              <IBLPagination
                currentPage={page}
                totalPages={numPages}
                onPageChange={handleSetPage}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Mentorslistmodalbox;
